import {  Hussle_Logo } from "../assets/icons";
const PoweredBy = () => {
  return (
    <div className="flex flex-row justify-center items-center">
      <span className="text-neutral-500 text-xs mt-0.5 mr-1">Powered By</span>
      <img src={Hussle_Logo} width={65} className="ml-1 mt-[-2px]"></img>
    </div>
  );
};

export default PoweredBy;
